<template>
  <ManuallyExpandableImagePreview
      ref="imagePreview"
      :class="{selected: selected}"
      :filter="filter"
      :image="image"
      :small-width="landscape ? '188px' : null"
      class="previewContainer"
      small-height="128px"
      @select="onSelect"
  />
</template>

<script lang="ts">
import Component from 'vue-class-component'
import BasicComponent from "@/global/BasicComponent";
import {Prop} from "vue-property-decorator";
import ImagePreview from "@/components/ImagePreview.vue";
import {ImageDto, ImageOrientationDto} from "@swagger";
import ManuallyExpandableImagePreview from "@/components/ManuallyExpandableImagePreview.vue";

@Component({
  components: {ManuallyExpandableImagePreview, ImagePreview}
})
export default class SelectableImagePreview extends BasicComponent {

  @Prop(Boolean) selected: boolean;
  @Prop(Object) image: ImageDto;
  @Prop(String) filter: string;

  get landscape() {
    return this.image.orientation === ImageOrientationDto.LANDSCAPE;
  }

  openPreview() {
    const ref: ImagePreview = this.$refs.imagePreview as ImagePreview;
    if (!ref) return;
    ref.openDialog();
  }

  onSelect() {
    this.$emit("select");
  }

}

</script>
<style lang="scss" scoped>
.previewContainer {
  border: 3px solid transparent;
  margin: 2px;

  &.selected {
    border: 3px solid rgb(68, 138, 255);
  }
}
</style>